@use '../../styling/colors.scss' as *;

.ResultsFooter {
  background-color: $theme-color-sub-background;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  border: 1px solid $theme-color-borders;
  border-radius: 0 0 6px 6px;
}
